import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/auth/user';
import { Notification, NotificationsModel } from 'src/app/models/Notification';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LookupsService } from 'src/app/services/lookups.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { SignalEventType } from 'src/app/services/signalR/SignalModel';
import { SignalRService } from 'src/app/services/signalR/SignalR.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  @Output() sidebarTrigger = new EventEmitter();
  notificationNumber: number = 0;
  currentUser: User|null = new User();
  userMenu = false;
  shouldShow = false;

  notifLoading = false;
  pageNumber = 0;
  pageSize = 10;
  pageCount: number = 0;
  notificationMenu = false;
  notificationsResult: any = {
    unSeenNotificationsCount: 0,
    totalCount: 0,
  };
  notificationsList: Notification[] = [];
  NotificationsModel = new NotificationsModel();
  activeAlerts = {};
  subscriptions: Subscription[] = [];

  actionsPermissions: any;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialog,
    public navService: NavigationService,
    private authenticationService: AuthenticationService,
    private notificationsService: NotificationsService,
    private signal: SignalRService,
    public LookupsService: LookupsService
  ) {
    this.signal.startConnection();
    this.GetUnseenNotificationCount();
    this.currentUser = this.authenticationService.currentUserValue;

    this.authenticationService.actionsPermissions.subscribe((data: any) => {
      this.actionsPermissions = data;
    });

    // this.signalRService.LogOut(this, this.getOut);
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.LogOut)
        .subscribe(message => { this.getOut(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.MobNotificationUnreadCountNumber)
        .subscribe(message => {
          this.updateNotification(message.data);
        })
    )
  }
  getOut(data: any) {
    Swal.fire({
      title: this.translate.instant('swalMsg.Sorry'),
      text:  localStorage.getItem('language') == 'ar' ? data.msgAr : data.msgEn,
      icon: 'warning',
      confirmButtonText: this.translate.instant('swalMsg.Ok'),
    });
    this.logout();
  }

  ngOnInit() {

  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  // SignalR
  updateNotification(data: any) {
    this.notificationsResult.unSeenNotificationsCount = data.count?.NotificationUnreadCountNumber;
    this.signal.notify('You have a new notification');
  }

  // Actions
  changeLanguage() {
    if (localStorage.getItem('language') === 'en') {
      localStorage.setItem('language', 'ar');
    } else {
      localStorage.setItem('language', 'en');
    }
    window.location.reload();
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  // Notifications
  GetUnseenNotificationCount() {
    this.notificationsService.GetUnseenNotificationCount().subscribe(
      result => {
        this.notificationsResult.unSeenNotificationsCount = result;
      }, err => {
        console.error(err);
      });
  }
  openNotificationPanel() {
    this.notificationMenu = !this.notificationMenu;
    this.userMenu = false;
    this.getNotifications();
  }
  getNextPage() {
    if (this.pageNumber < this.pageCount - 1) {
      this.pageNumber += 1;
      this.getNotifications(false);
    }
  }
  getNotifications(update = true) {
    if (update) {
      this.pageNumber = 0;
      this.notificationsList = [];
    }
    this.notifLoading = true;
    this.NotificationsModel.pageSize = this.pageSize;
    this.NotificationsModel.pageNumber = this.pageNumber;
    this.notificationsService.GetNotifications(this.NotificationsModel).subscribe(
      result => {
        this.notifLoading = false;
        this.notificationsResult = result;
        this.pageCount = Math.ceil(this.notificationsResult.totalCount / this.pageSize);
        this.notificationsList = this.notificationsList.concat(this.notificationsResult.pageData);
        this.notificationsResult.unSeenNotificationsCount = 0;
      }, err => {
        this.notifLoading = false;
        console.error(err);
      });
  }

  toggelSidebar() {
    const state = this.navService.sidebarState;
    state.sidenavOpen = !state.sidenavOpen;
    this.navService.sidenavOpen.next(state.sidenavOpen);
  }

}
